import { useState } from "react";
import { X } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { GALLERY_IMAGES } from "../lib/content";

export default function Gallery() {
  const [active, setActive] = useState(null);

  // Repeating bento pattern: most images are 4:3 squares, with a featured wide one every 5 tiles
  const getLayout = (index) => {
    const pattern = index % 10;
    if (pattern === 0) return "md:col-span-2 aspect-[16/9]";
    if (pattern === 5) return "md:col-span-2 aspect-[16/9]";
    return "aspect-[4/3]";
  };

  return (
    <div data-testid="gallery-page">
      <PageHero
        eyebrow="Our work"
        title="Proof"
        accent="in the pavement."
        subtitle="A closer look at recent paving, sealing and repair projects from across our service area."
        testId="gallery-hero"
      />

      <section className="py-20 md:py-28" data-testid="gallery-grid-section">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {GALLERY_IMAGES.map((img, i) => (
              <button
                key={i}
                onClick={() => setActive(img)}
                data-testid={`gallery-item-${i}`}
                className={`group relative overflow-hidden border border-[#27272a] hover:border-[#f59e0b] transition-colors ${getLayout(i)}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#09090b]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="text-xs uppercase tracking-[0.25em] text-[#f59e0b] font-bold">
                    View
                  </div>
                </div>
                <div className="absolute top-4 left-4 w-9 h-9 border border-[#f59e0b]/60 text-[#f59e0b] flex items-center justify-center font-display font-black text-xs bg-[#09090b]/60 backdrop-blur">
                  {String(i + 1).padStart(2, "0")}
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {active && (
        <div
          className="fixed inset-0 z-[100] bg-[#09090b]/95 backdrop-blur-xl flex items-center justify-center p-4 md:p-10"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 border border-[#27272a] hover:border-[#f59e0b] text-[#fafaf9] flex items-center justify-center transition-colors"
            onClick={() => setActive(null)}
            data-testid="gallery-lightbox-close"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
          <img
            src={active.src}
            alt={active.alt}
            className="max-w-full max-h-[85vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
